<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 19V6L3 2h15v3h2c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v5c0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 20 14h-2v5H6Zm2-2h8V4H7l1 1.3V17Zm10-5h2V7h-2v5Zm-6 4h3V5h-3v11Zm-9 6v-2h18v2H3Z"
    />
  </svg>
</template>
